import React from "react";
import { Button } from "antd";
import { BUTTON_TEXT, TEXT_CONSTANTS } from "../../../constants/Constants";

const SaveButton = ({ onClick, disabled }) => {
  return (
    <Button
      disabled={disabled}
      style={{
        background: "#fff",
        border: "1px solid #004481",
        borderRadius: "25px",
        fontSize: "16px",
        fontWeight: 600,
        color:"#1F405A",
        padding: "8px 25px",
        transition: "background-color .3s, color .3s, border-color .3s"
      }}
      onClick={onClick}
    >
      {BUTTON_TEXT.SAVE}
    </Button>
  );
};

export default SaveButton;
